import { openUrl, isNative } from './utils.js';
import { config } from './config.js';

const BOM = {
    window: window,
    document: document
};
/*
* @type
* *
0 没有 1 success, 2 info, 3 error
* */
BOM.alert = function(msg, type = 3) {
    if (isNative()) {
        try {
            openUrl('local://toast?text=' + msg + '&type=' + type);
        } catch (e) {
            BOM.window.alert(msg);
        }
    } else {
        BOM.window.alert(msg);
    }
};
BOM.log = function(msg) {
    if (typeof console != 'undefined') {
        console.log(msg);
    }
};
//跳转到线上异常页面
function showErrorPage(msg) {
    BOM.window.location.href = config.WEBPROTOCOL + 'error?err_msg=' + encodeURIComponent(msg);
}

export { BOM, showErrorPage };
